import React from 'react';
import { GridOverlay } from '@mui/x-data-grid-pro';
import { ReactComponent as HookIcon } from 'assets/icons/hook.svg';

interface Props {
  openAddModal: () => void;
  variant: 'shipment' | 'container';
  className?: string;
}

export const AddOverlay: React.FC<Props> = (props) => {
  const { openAddModal, variant, className } = props;
  return (
    <GridOverlay className={className}>
      <div className="flex flex-col space-y-4 items-center" style={{ zIndex: 1099 }}>
        <HookIcon />
        <div className="flex flex-col items-center">
          <h3 className="text-dark">Your {variant} watchlist is empty!</h3>
          <p
            className="text-blue-900 underline font-semibold cursor-pointer"
            onClick={() => openAddModal()}
          >
            Add {variant} to track
          </p>
        </div>
      </div>
    </GridOverlay>
  );
};
AddOverlay.displayName = 'ContainerTable.AddOverlay';
